<template>
  <v-card width="94%" elevation="0" class="ml-5">
    <v-container>
      <v-row style="border-bottom: 10px"
        ><v-col>
          <exo-input-select :root="_self" name="initialOrbitDefinitionType" />
          <div v-show="inputs.initialOrbitDefinitionType == 'TLE'">
            Initial TLE
            <TLEDecoder
              :tle.sync="inputs.initialTle"
              :isExpanded="false"
              :expandDisabled="false"
            ></TLEDecoder>
          </div>
          <div v-show="inputs.initialOrbitDefinitionType == 'ORBIT'">
            <exo-input-ref-notparametric
              :canCreate="false"
              :canEdit="false"
              :root="_self"
              name="initialOrbit"
              type="orbit"
              componentRoute="/numericalorbit"
            /></div
        ></v-col>
        <v-col>
          <exo-input-select :root="_self" name="finalOrbitDefinitionType" />
          <div v-show="inputs.finalOrbitDefinitionType == 'TLE'">
            Final TLE
            <TLEDecoder
              :tle.sync="inputs.finalTle"
              :isExpanded="false"
              :expandDisabled="false"
            ></TLEDecoder>
          </div>
          <div v-show="inputs.finalOrbitDefinitionType == 'ORBIT'">
            <exo-input-ref-notparametric
              :canCreate="false"
              :canEdit="false"
              :root="_self"
              name="finalOrbit"
              type="orbit"
              componentRoute="/numericalorbit"
            /></div></v-col
      ></v-row>
      <v-row>
        <exo-input-double :root="_self" name="initialSpaceObjectMass" />
      </v-row>

      <v-row
        ><v-btn color="primary" @click="compute()" :disabled="!inputsValid"
          >Display results
        </v-btn></v-row
      >
    </v-container>
    <v-container v-if="results != null">
      <v-row
        ><v-col
          ><FullscreenGraphComponent :traces="traces" :layout="layout" /></v-col
      ></v-row>
    </v-container>
  </v-card>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import dataTools from '../../tools/data.js'
import fieldsDescription from '../../tools/fieldsDescription.json'
import numericalMixin from '../../mixins/numericalForms.js'
import errorMixin from '../../mixins/logHandler.js'
import TLEDecoder from './TLEDecoder'
import FullscreenGraphComponent from '../../views/Asterx/FullscreenGraphComponent'
import defenseMixin from '../../mixins/defense.js'

export default {
  name: 'PropulsionCharacterisation',

  components: { TLEDecoder, FullscreenGraphComponent },

  mixins: [formMixin, numericalMixin, errorMixin, defenseMixin],

  mounted() {
    this.refreshReferences()
  },

  props: {},

  watch: {},

  computed: {
    allPropertiesList() {
      return [
        ...this.getOptionalPropertiesList(this.inputs),
        ...this.getRequiredPropertiesList(this.inputs)
      ]
    },
    traces() {
      const traces = []
      for (let i = 0; i < this.results.thrustValues.length; i++) {
        traces.push(
          this.buildTrace(
            this.results.ispValues[i],
            this.results.thrustValues[i],
            this.results.thrustDurations[i]
          )
        )
      }
      return traces
    },
    layout() {
      return {
        xaxis: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['ispValues'],
              this.resultsContext
            )
          }
        },
        yaxis: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['thrustValues'],
              this.resultsContext
            )
          }
        }
      }
    }
  },

  data() {
    return {
      enableFormCache: false,
      results: null,
      enumPropertiesList: this.getEnumProperties(),
      resultsContext: 'PropulsionCharacterisationResult',
      orbitsNotParametrics: [],

      inputs: {
        name: 'AAAAAAAAAAAA',
        initialOrbitDefinitionType: this.getDefaultValue(
          'initialOrbitDefinitionType'
        ),
        finalOrbitDefinitionType: this.getDefaultValue(
          'finalOrbitDefinitionType'
        ),
        initialOrbit: this.getDefaultValue('initialOrbit'),
        finalOrbit: this.getDefaultValue('finalOrbit'),
        initialTle: this.getDefaultValue('initialTle'),
        finalTle: this.getDefaultValue('finalTle'),
        initialSpaceObjectMass: this.getDefaultValue('initialSpaceObjectMass')
      }
    }
  },

  methods: {
    refreshTable() {},

    refreshReferences() {
      this.refreshNumericalOrbits()
    },

    refreshNumericalOrbits() {
      let self = this
      this.$http
        .get(this.getAPI('orbitdefinitions'))
        .then((response) => {
          self.orbitsNotParametrics = response.data
            .filter((obj) => !obj.displayedName.endsWith('*'))
            .map((obj) => ({ value: obj, text: obj.displayedName }))
            .sort((a, b) =>
              a.text.toLowerCase() < b.text.toLowerCase() ? -1 : 1
            )
        })
        .catch((e) => {
          self.displayMessage(
            'Error getting list of numerical orbits. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )
        })
    },

    getSubTypes(instance) {
      let types = {
        initialOrbitDefinitionType: instance.initialOrbitDefinitionType,
        finalOrbitDefinitionType: instance.finalOrbitDefinitionType
      }
      return types
    },

    getOptionalPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      return dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'optional'
      )
    },

    getRequiredPropertiesList(instance) {
      let subTypes = this.getSubTypes(instance)
      let objectType = this.getCurrentFormType()
      let requiredList = dataTools.getPropertiesList(
        fieldsDescription[objectType],
        subTypes,
        'required'
      )
      return requiredList
    },

    getCurrentFormType() {
      return 'PropulsionCharacterisationRequest'
    },

    getRefList(param) {
      if (param === 'initialOrbit' || param === 'finalOrbit') {
        return this.orbitsNotParametrics
      }
    },
    buildTrace(ispList, thrustList, thrustDuration) {
      const displayedDuration = this.getDisplayValueFromPath(
        thrustDuration,
        ['thrustDurations'],
        this.resultsContext
      )
      return {
        x: ispList.map((value) =>
          this.getGuiValueFromPath(value, ['ispValues'], this.resultsContext)
        ),
        y: thrustList.map((value) =>
          this.getGuiValueFromPath(value, ['thrustValues'], this.resultsContext)
        ),
        name: `Thrust duration: ${displayedDuration} s`,
        hovertemplate:
          `Thrust duration: ${displayedDuration} s` +
          '<br><br><b>%{xaxis.title.text}</b>: %{x}' +
          '<br><b>%{yaxis.title.text}</b>: %{y}'
      }
    },
    async compute() {
      this.results = await this.$http
        .post(this.getCurrentAPI() + '/' + 'computewithoutsaving', this.inputs)
        .then(function (response) {
          return {
            thrustValues: response.data.thrustValues,
            ispValues: response.data.ispValues,
            thrustDurations: response.data.thrustDurations
          }
        })
        .catch((e) => {
          this.displayMessage(
            'Error during calculations. ',
            e,
            'NumericalMissionErrorDisplay',
            'error'
          )

          return null
        })
    }
  }
}
</script>

<style scoped></style>
